<template>
  <kst-table action input-mode :data="userPackagingList">
    <b-table-column cell-class="ks-col-nopad" header-class="p-0" width="1">
      <template #header>
        <kst-header-blank />
      </template>
      <template #default="{ row }">
        <kst-tooltip v-if="row.Errors.length > 0" error-mode>
          <template #content>
            <kst-list :items="row.Errors"/>
          </template>
          <kst-icon error-mode/>
        </kst-tooltip>
      </template>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      field="Name"
      :label="PackagingCatalog.Name.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="PackagingCatalog"
        :index="index" :disabled="row.ID > 0"
        @input="handleName" @error="handleErrors"
      />
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="ks-col-qty"
      field="Qty"
      :label="PackagingCatalog.Qty.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="PackagingCatalog"
        :index="index" :disabled="row.ID > 0"
        @error="handleErrors"
      />
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="ks-col-price"
      field="SellPrice"
      :label="PackagingCatalog.SellPrice.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="PackagingCatalog"
        :index="index" @error="handleErrors"
      />
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="ks-col-weight-full"
      field="Weight"
      :label="PackagingCatalog.Weight.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="PackagingCatalog"
        :index="index" @error="handleErrors"
      />
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="ks-col-item-active"
      field="IsActive"
      :label="PackagingCatalog.IsActive.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="PackagingCatalog"
        :index="index" :disabled="row.ID <= 0"
        @input="handleIsActive" @error="handleErrors"
      />
    </b-table-column>

    <template #action="{ row, index }">
        <template v-if="row.ID <= 0">
          <kst-tooltip delete-mode hover-only :content="Model.ItemPackaging.Module.FullName">
            <kst-button delete-mode is-round @click="handleRowDelete(index)"/>
          </kst-tooltip>
        </template>
    </template>
  </kst-table>
</template>

<script>
import DialogMixin from "../../../mixins/DialogMixin.js";
import Info from "../ItemInfo.js";
import Model from "../ItemModel.js";
import PackagingCatalog from "../PackagingCatalog.js";

export default {
  mixins: [DialogMixin],
  props: {
    userData: Object,
    userPackagingList: Array
  },
  data: () => ({
    Model: Model,
    PackagingCatalog: PackagingCatalog
  }),
  methods: {
    handleName() {
      Model.updatePackagingsErrors(this.userData, this.userPackagingList);
    },
    handleIsActive() {
      Model.updatePackagingsErrors(this.userData, this.userPackagingList);
    },

    handleRowDelete(index) {
      this.showConfirm(
        Info.Message.Edit_Packaging_ConfirmDelete,
        this.handleRowDelete_confirm,
        null,
        index
      );
    },
    handleRowDelete_confirm(index) {
      this.userPackagingList.splice(index, 1);
      Model.updateDefaultPackaging(this.userData, this.userPackagingList);
    },

    handleErrors(errors, field, index) {
      Model.setPackagingErrors(this.userPackagingList[index], field, errors);
    }
  }
}
</script>